import { SaveButton, Toolbar } from 'react-admin';

export const CustomToolbar: React.FC = () => (
  <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
    <SaveButton />
  </Toolbar>
);
